import {
    SliceFactory,
    FetchCollectionData,
    FetchItemDataType,
    ApiCollectionResponse,
} from '@europrocurement/l2d-redux-utils';
import { getOrderParameters, Orders } from '@europrocurement/l2d-domain/utils/orders';
import {
    ConfigurationParameters as OffreConfigurationParameters,
    Configuration,
    CatalogueApi,
    CatalogueJsonldCatalogueReadCatalogueReadGrilleTarifaireCatalogueReadFull,
    CatalogueApiApiCataloguesGetCollectionRequest,
} from '../../../openApi/ApiOffre';
import { CATALOGS_FULL_SLICE_NAME, OFFRE_REDUCER_NAME } from '../constants';

export type CatalogFullApiObject =
    CatalogueJsonldCatalogueReadCatalogueReadGrilleTarifaireCatalogueReadFull;

export type CatalogsFull = CatalogFullApiObject;

export const mapperCatalogsFull = function (catalogs: CatalogFullApiObject) {
    return {
        ...catalogs,
    } as CatalogsFull;
};

export function createCatalogsFullSlice(configuration: OffreConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new CatalogueApi(conf);

    // apiPrescripteursCataloguesGetCollection
    const fetchCatalogsCollection: FetchCollectionData<CatalogFullApiObject> = ({
        search,
        pagination: { page, itemsPerPage },
        xIdSociete,
        filters,
        orders,
    }) => {
        /** Field mapper : Map column field name with api filter name */
        const ordersSchema = {
            groupement: 'groupementLibelle',
            offre: 'offreLibelle',
        };

        /** Get collection default orders */
        const defaultOrders: Orders = {
            orderOffreLibelle: 'asc',
            orderGroupementLibelle: 'asc',
            orderNomCommercial: 'asc',
        };

        const orderParameters = getOrderParameters(orders, defaultOrders, ordersSchema);

        let multiFieldSearch;

        /**
         * Manage search filters.
         */
        if (search && search !== '') {
            multiFieldSearch = search;
        }

        const requestParameters: CatalogueApiApiCataloguesGetCollectionRequest = {
            xIdSociete,
            page: page + 1,
            itemsPerPage,
            ...filters,
            domaineSocietesSocieteId: xIdSociete,
            ...orderParameters,
            multiFieldSearch,
        };

        return api
            .apiCataloguesFullGetCollection(requestParameters)
            .then((res) => res.data)
            .catch((error) => {
                console.error(error);
            }) as Promise<ApiCollectionResponse<CatalogFullApiObject>>;
    };

    const fetchCatalogsItem: FetchItemDataType<CatalogFullApiObject> = ({ idItem, xIdSociete }) =>
        api
            .apiCataloguesIdGet({ id: String(idItem), xIdSociete })
            .then((res) => res.data) as Promise<CatalogFullApiObject>;

    const { slice: catalogsFullSlice, dataSourcesThunks: catalogsFullDataSourcesThunks } =
        SliceFactory.createSlice<CatalogFullApiObject, CatalogsFull>(
            CATALOGS_FULL_SLICE_NAME,
            OFFRE_REDUCER_NAME,
            [],
            fetchCatalogsCollection,
            fetchCatalogsItem,
            mapperCatalogsFull,
        );

    return { catalogsFullSlice, catalogsFullDataSourcesThunks };
}
